import { render } from "./FolderContents.vue?vue&type=template&id=3875303e&scoped=true"
import script from "./FolderContents.vue?vue&type=script&lang=js"
export * from "./FolderContents.vue?vue&type=script&lang=js"

import "./FolderContents.vue?vue&type=style&index=0&id=3875303e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3875303e"]])

export default __exports__